export interface AdminDailyAnalyticsPoint {
  date: string;
  visits: number;
  uniqueVisitors: number;
  sessions: number;
  visitedArchives: number;
}

export interface AdminDailyAnalyticsData {
  from: string;
  to: string;
  timeZone: string;
  lastAggregatedAt: string | null;
  daily: AdminDailyAnalyticsPoint[];
}

export interface AdminDailyAnalyticsResponse {
  data: AdminDailyAnalyticsData;
}

export interface AdminAnalyticsSummary {
  totalVisits: number;
  averageDailyUniqueVisitors: number;
  peakDailyUniqueVisitors: number;
  averageDailyVisitedArchives: number;
}

const average = (values: number[]): number => {
  if (values.length === 0) return 0;
  return values.reduce((sum, value) => sum + value, 0) / values.length;
};

export const calculateAdminAnalyticsSummary = (
  daily: AdminDailyAnalyticsPoint[],
): AdminAnalyticsSummary => ({
  totalVisits: daily.reduce((sum, day) => sum + day.visits, 0),
  averageDailyUniqueVisitors: average(
    daily.map((day) => day.uniqueVisitors),
  ),
  peakDailyUniqueVisitors: Math.max(
    0,
    ...daily.map((day) => day.uniqueVisitors),
  ),
  averageDailyVisitedArchives: average(
    daily.map((day) => day.visitedArchives),
  ),
});
